export const SEND_CONNECTIONS_EMAILS_OPTION_TEXT = {
    id: 'oe.meeting.sendConnectionsEmails',
    defaultMessage: 'Send Connections Emails',
    description: 'Label text'
};

export const EDIT_MEETING_OPTION_TEXT = {
    id: 'oe.meeting.editMeeting',
    defaultMessage: 'Edit Meeting',
    description: 'Label text'
};

export const RUN_MEETING_OPTION_TEXT = {
    id: 'oe.meeting.runMeeting',
    defaultMessage: 'Run Meeting',
    description: 'Label text'
};

export const MEETING_GUIDELINES_TEXT = {
    id: 'oe.meeting.meetingGuidelines',
    description: 'Label text',
    defaultMessage: 'Meeting Guidelines'
};

export const REGISTRANTS_TEXT = {
    id: 'oe.connections.registrants',
    description: 'Input Label',
    defaultMessage: 'Registrants',
};

export const EDIT_REGISTRANTS_TEXT = {
    id: 'oe.connections.editRegistrants',
    description: 'Button text',
    defaultMessage: 'Edit Registrants'
};

export const UNIQUE_TEXT = {
    id: 'oe.connections.unique',
    description: 'Button text',
    defaultMessage: 'Unique'
};

export const EDIT_CONNECTION_DETAILS = {
    id: 'oe.connection.editDetails',
    description: 'Edit Popover header text',
    defaultMessage: 'Edit Connection Details'
};

export const MANAGE_PODIUM_ACCESS_TEXT = {
    id: 'oe.connections.managePodiumAccess',
    description: 'Button text',
    defaultMessage: 'Manage Podium Access',
};